import { HttpProvider } from './../http/http';
import { Injectable } from '@angular/core';
import { OrdemServicoIntegradaModel, RetornoIntegradaModel } from '../../app/models/OrdemServicoIntegradaModel';

@Injectable()
export class OrdemServicoProvider {

  constructor(public httpSrv: HttpProvider) {
  }

  async setOrdemServicoIntegrada(cnpj: string, model: OrdemServicoIntegradaModel, dms,  loading: number = 1, verconexao: number = 1, mensagem: string = "Enviando as informações...") : Promise<RetornoIntegradaModel> {
    try {

      let ResultConn;

      if(dms == 10 || dms == 11 || dms == 12)
      {
        ResultConn = await this.httpSrv.postCamp('gerarOrdemServico/' + cnpj, JSON.stringify(model), loading, verconexao, mensagem);
      }
      else
      {
        ResultConn = await this.httpSrv.postDms('abriros/' + cnpj+'/' + dms, JSON.stringify(model));
      }


      
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return <RetornoIntegradaModel>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao enviar ordem de servico Integrada online', error);
    }
  }


  async setCategoriaOS(cnpj: string, model: any, dms) : Promise<RetornoIntegradaModel> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postDmsCamp('getCategoriaOs/' + cnpj, JSON.stringify(model),0);
     
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao buscar a categoria', error);
    }
  }


  async getConsultarOs(cnpj: string, model: any) : Promise<RetornoIntegradaModel> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postCamp('consultarOs/' + cnpj, JSON.stringify(model));
     
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao buscar a os', error);
    }
  }

  async getConsultarApontamento(cnpj: string, model: any) : Promise<any> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postCamp('consultarApontamento/' + cnpj, JSON.stringify(model));
     
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao buscar a os', error);
    }
  }

  async getConsultarChipQuadro(model: any) : Promise<any> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postCamp('consultarChipQuadro', JSON.stringify(model));
     
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao buscar o chip', error);
    }
  }

  async setMarcacaoApontamento(cnpj: string, model: any) : Promise<RetornoIntegradaModel> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postCamp('marcacaoApontamento/' + cnpj, JSON.stringify(model));
     
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao buscar a os', error);
    }
  }

  
  async postEmailPreOS(base64: any){
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.postCamp('enviaremailpreos/', JSON.stringify(base64));

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data);
        return "salvo com sucesso";
      }
    } catch (error) 
    {
      console.log('problema ao enviar emil da ordeme de servico', error);
    }
  }

  async postPreOrdemChecklist(linkchecklist: string, preos: any){
    try {
      let formData = new FormData();
      formData.append('orcamento', preos);
      let ResultConn = await this.httpSrv.curlPreOrdemChecklist(linkchecklist, formData, 0, 1, "Gerando Processo...", 600000);
      if(ResultConn.success){
          console.log("data ", ResultConn.data);
          console.log("ResultConn ", ResultConn);
          return ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao enviar emil da ordeme de servico', error);
    }
  }

  async postOSManual(cnpj: string, model:any){
    try {
      let ResultConn = await this.httpSrv.postCamp("inserirOsManual/"+cnpj, model, 1, 1, "Salvando numero OS manual...", 600000);
      if(ResultConn.success){
          console.log("data ", ResultConn.data);
          console.log("ResultConn ", ResultConn);
          return ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao salvar numero os manual', error);
    }
  }

  async consultarListaOS( model:any){
    try {
      let ResultConn = await this.httpSrv.postCamp("consultarListaOS/", model, 1, 1, "consultando OS...", 600000);
      if(ResultConn.success){
          console.log("data ", ResultConn.data);
          console.log("ResultConn ", ResultConn);
          return ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao consultar', error);
    }
  }


  async getBuscarModeloVeiculo(cnpj: string, model: any): Promise<any>{
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.postCamp('buscarModeloVeiculo/'+cnpj, JSON.stringify(model),0);

      console.log('ResultConn',ResultConn);
      if (ResultConn)
      {
        //console.log('providers',ResultConn.data.clienteook);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao verificar se o cliente esta cadastrado no dms', error);
    }
  }
  async getCliente(cnpj: string, model: any): Promise<any>{
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.postCamp('consultarCliente/'+cnpj, JSON.stringify(model));

      console.log('ResultConn',ResultConn);
      if (ResultConn)
      {
        //console.log('providers',ResultConn.data.clienteook);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao verificar se o cliente esta cadastrado no dms', error);
    }
  }

  async getCores(cnpj: string): Promise<any>{
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.getCamp('cor/'+cnpj, 0);

      console.log('ResultConn',ResultConn);
      if (ResultConn)
      {
        //console.log('providers',ResultConn.data.clienteook);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao carregar as cores', error);
    }
  }

  async postVeiculo(cnpj: string, model: any): Promise<any>{
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.postCamp('inserirVeiculo/'+cnpj, JSON.stringify(model));

      console.log('ResultConn',ResultConn);
      if (ResultConn)
      {
        //console.log('providers',ResultConn.data.clienteook);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao cadastrar veiculo no dms', error);
    }
  }

  async postCliente(cnpj: string, model: any): Promise<any>{
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.postCamp('inserirCliente/'+cnpj, JSON.stringify(model));

      console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        //console.log('providers',ResultConn.data.clienteook);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao cadastrar cliente no dms', error);
    }
  }

  async getCep(cep: string) : Promise<any> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.curlGet(`https://viacep.com.br/ws/${cep}/json/`,undefined, 0);
     
      console.log('ResultConn',ResultConn);
      if (ResultConn)
      {
        console.log("dentro do if");
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao buscar a categoria', error);
      return null
    }
  }

  async getMarcas(): Promise<Array<string>>{
    try {

      let ResultConn;

        ResultConn = await this.httpSrv.getCamp('marcas');

      console.log('ResultConn',ResultConn);
      if (ResultConn)
      {
        //console.log('providers',ResultConn.data.clienteook);
        return <Array<string>>ResultConn.data.map(objeto => objeto.nome);
      }
    } catch (error) 
    {
      console.log('problema ao pegar as marcas', error);
    }
  }

  async setAssinaturaOrdemServico(codigointerno: string, numos: string, dados:any) : Promise<any> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postCamp('setAssinatura/' + codigointerno +'/'+numos, JSON.stringify(dados));
   
      console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao atualizar a assinatura da OS', error);
    }
  }

  async atualizarCliente(cnpj: string, dados:any) : Promise<any> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.postDmsCamp('atualizarCliente/' + cnpj, JSON.stringify(dados));
   
      console.log('ResultConn',ResultConn);
      if (ResultConn.success)
      {
        console.log('providers',ResultConn.data);
        return <any>ResultConn.data;
      }
    } catch (error) 
    {
      console.log('problema ao atualizar a assinatura da OS', error);
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/ordem-servico/ordem-servico.ts